import Axios, { AxiosInstance } from 'axios';
import EndpointFactory from 'axios-endpoints';

import useInterceptors from '../interceptor';
import accountsInterceptor from '../interceptor/interceptors/accounts';

const API: AxiosInstance = useInterceptors(Axios.create(), [
  accountsInterceptor,
]);

const Endpoint = EndpointFactory(API);

// accounts
export const postalCodeEndpoint = new Endpoint<{ postalCode: string }>(({ postalCode }) => `/location?postalCode=${postalCode}`);
export const stateEndpoint = new Endpoint<{ state: string }>(({ state }) => `/cities?state=${state}`);

const auth = '/auth';
export const signinEndpoint = new Endpoint<{}>(() => `${auth}/login`);
export const validateTokenEndpoint = new Endpoint<{}>(() => `${auth}/validate`);

const users = '/users';
export const logoutEndpoint = new Endpoint<{}>(() => `${users}/me/logout`);
export const signupEndpoint = new Endpoint<{}>(() => `${users}`);
export const detailsEndpoint = new Endpoint<{}>(() => `${users}/me`);

export const userExistsEndpoint = new Endpoint<{}>(() => `${users}/exists`);
export const passwordRecoveryEndpoint = new Endpoint<{}>(() => `${users}/password-recovery`);

export const userAddressesEndpoint = new Endpoint<{ userId: number }>(({ userId }) => `${users}/${userId}/addresses`);

export const userByIdEndpoint = new Endpoint<{ userId: number }>(({ userId }) => `${users}/${userId}`);
export const userPhoneEndpoint = new Endpoint<{ id: number }>(({ id }) => `${users}/${id}/phone-numbers`);
